module.exports = __webpack_public_path__ + "6b0746bb2cc6d2d18ae590eeadd1c7eb.jpg";